<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>睿世力小程序商城</el-breadcrumb-item>
      <el-breadcrumb-item>套餐管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.packagename" placeholder="请输入套餐名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Packagename" label="套餐名称" min-width="15%"></el-table-column>
          <el-table-column prop="Packageprice" label="套餐价" min-width="10%"></el-table-column>
          <el-table-column prop="Productidlist" label="套餐内产品编号" min-width="50%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加套餐" name="three">
      <el-form :model="myForm" ref="myForm" label-width="170px">
        <el-form-item label="套餐名称" class="addAdminForm">
          <el-input v-model="myForm.packagename"></el-input>
        </el-form-item>
        <el-form-item label="套餐价" class="addAdminForm">
          <el-input v-model="myForm.packageprice"></el-input>
        </el-form-item>
        <el-form-item label="套餐内产品编号" class="addAdminForm">
          <el-input v-model="myForm.productidlistsub"></el-input>
          <el-button type="text" @click="clickAddSub()">增加</el-button>
          <li v-for="item,index in myForm.productidlist" :key="index">
            编号：{{item.v}}
            <el-button type="text" @click="clickDeleteSub(index)">删除</el-button>
          </li>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickAdd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- start -->
    <el-tab-pane label="修改套餐" name="five" disabled="disabled">
      <el-form :model="myForm" ref="myForm" label-width="170px">
        <el-form-item label="套餐名称" class="addAdminForm">
          <el-input v-model="myForm.packagename"></el-input>
        </el-form-item>
        <el-form-item label="套餐价" class="addAdminForm">
          <el-input v-model="myForm.packageprice"></el-input>
        </el-form-item>
        <el-form-item label="套餐内产品编号" class="addAdminForm">
          <el-input v-model="myForm.productidlistsub"></el-input>
          <el-button type="text" @click="clickAddSub()">增加</el-button>
          <li v-for="item,index in myForm.productidlist" :key="index">
            编号：{{item.v}}
            <el-button type="text" @click="clickDeleteSub(index)">删除</el-button>
          </li>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickSave">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyOptometristPackage',
  data () {
    return {
      activeName: 'first',
      myForm: {
        id:0,
        packagename: '',
        packageprice: '',
        productidlist: [],
        productidlistsub: ''
      },
      // 查询
      keywords: {
        packagename: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetOptometristPackageNum()
    this.apiGetOptometristPackageList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetOptometristPackageNum()
      this.apiGetOptometristPackageList()
    },
    clickedit (row) {
      this.myForm.id = row.Id
      this.myForm.packagename = row.Packagename
      this.myForm.packageprice = row.Packageprice
      this.myForm.productidlist = JSON.parse(row.Productidlist)
      this.myForm.productidlistsub = ''
      this.activeName = 'five'
    },
    clickAdd () {
      this.apiAddOptometristPackage()
    },
    clickAddSub () {
      this.myForm.productidlist.push({v:this.myForm.productidlistsub})
      this.myForm.productidlistsub = ''
    },
    clickDeleteSub (index) {
      var buflist = []
      for (var j = 0, len = this.myForm.productidlist.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.myForm.productidlist[j])
        }
      }
      this.myForm.productidlist = buflist
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelOptometristPackage(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetOptometristPackageNum()
      this.apiGetOptometristPackageList()
    },
    clickSave(){
      this.apiEditOptometristPackage()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetOptometristPackageList()
    },
    apiGetOptometristPackageNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        packagename: that.keywords.packagename
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristPackageNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristPackageList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        packagename: that.keywords.packagename
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristPackageList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddOptometristPackage: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        packagename: that.myForm.packagename,
        packageprice: that.myForm.packageprice,
        productidlist: JSON.stringify(that.myForm.productidlist)
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddOptometristPackage, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristPackageNum()
            that.apiGetOptometristPackageList()

            // 清空添加
            that.myForm.packagename = ''
            that.myForm.packageprice = ''
            that.myForm.productidlist = []
            that.myForm.productidlistsub = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditOptometristPackage: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.myForm.id,
        packagename: that.myForm.packagename,
        packageprice: that.myForm.packageprice,
        productidlist: JSON.stringify(that.myForm.productidlist)
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditOptometristPackage, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristPackageNum()
            that.apiGetOptometristPackageList()

            // 清空添加
            that.myForm.packagename = ''
            that.myForm.packageprice = ''
            that.myForm.productidlist = []
            that.myForm.productidlistsub = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelOptometristPackage: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelOptometristPackage, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristPackageNum()
            that.apiGetOptometristPackageList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    delaysearch () {
      var that = this
      setTimeout(function () {
        that.clicksearch()
      }, 2000)
    },
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
